<template>

    <section id="contact">

        <b-container class="content-wrapper">

            <scroll-item id="si-contact" data-relid="contact" data-relpath="/contact" @change="onChange">

                <b-row align-v="center" class="form-container justify-content-md-center">

                    <b-col lg="7" align-self="center">

                        <div class="section-header" v-if="(show && !submitted)">

                            <h2 class="form-heading"
                                data-aos="fade-right"
                                data-aos-duration="300"
                                data-aos-delay="200"
                                data-aos-easing="ease-in-out-quad"
                                data-aos-offset="0"
                                data-aos-anchor=""
                                data-aos-anchor-placement="top-bottom"
                                data-aos-once="">Contact!</h2>

                            <div class="form-intro"
                                 data-aos="fade"
                                 data-aos-duration="300"
                                 data-aos-delay="450"
                                 data-aos-easing="ease-in-out-quad"
                                 data-aos-offset="0"
                                 data-aos-anchor=""
                                 data-aos-anchor-placement="top-bottom"
                                 data-aos-once="">Whisper our name into the darkness 3 times, holla at <a href="tel:9174634002">917-463-4002</a>, or fill this sh*t out:</div>

                        </div>



                        <div class="form-errors" v-if="errors.length">
                            <strong>Please correct the following error(s):</strong>
                            <ul>
                                <li v-for="(error, $index) in errors" :key="$index">{{ error }}</li>
                            </ul>
                        </div>

                        <div class="form-wrapper"
                             data-aos="fade-up"
                             data-aos-duration="300"
                             data-aos-delay="180"
                             data-aos-easing="ease-in-out-quad"
                             data-aos-offset="0"
                             data-aos-anchor=""
                             data-aos-anchor-placement="top-bottom"
                             data-aos-once="">

                            <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="(show && !submitted)">

                                <b-form-row>

                                    <b-col>
                                        <b-form-group id="inputGroup1" label="Name *" label-for="inputName">
                                            <b-form-input id="inputName" type="text" maxlength="70" v-model="form.name" @focus.native="onFieldFocus" @blur.native="onFieldBlur" required placeholder=""></b-form-input>
                                        </b-form-group>
                                    </b-col>

                                    <b-col>
                                        <b-form-group id="inputGroup2" label="Email *" label-for="inputEmail" description="">
                                            <b-form-input id="inputEmail" type="email" maxlength="75" v-model="form.email" @focus.native="onFieldFocus" @blur.native="onFieldBlur" required placeholder=""></b-form-input>
                                        </b-form-group>
                                    </b-col>

                                </b-form-row>

                                <b-form-group id="inputGroup3" label="How can we help you? *" label-for="inputHelp" description="">
                                    <b-form-textarea id="inputHelp" :maxlength="maxCount" v-model="form.help" :rows="2" :max-rows="4" :no-resize="true" @keyup.native="charCountdown" @focus.native="onFieldFocus" @blur.native="onFieldBlur" required placeholder=""></b-form-textarea>
                                    <b-form-row>
                                        <b-col class="text-left">
                                            <b-form-text>Add a comment (up to {{ maxCount }} characters)</b-form-text>
                                        </b-col>
                                        <b-col class="text-right">
                                            <b-form-text :class="{ 'text-danger': exceededCount }">{{ remainingCount }}</b-form-text>
                                        </b-col>
                                    </b-form-row>
                                </b-form-group>

                                <!-- COLLAPSE CONTENT -->
                                <p v-b-toggle.collapse-1 class="formToggle" @click="toggleArrow">got more deets? <i class= "arrow"></i></p>
                                <b-collapse id="collapse-1" class="mt-2">
                                      <b-form-row>

                                          <b-col sm="12" md="4">
                                              <b-form-group id="inputGroup4" label="Number of Units" label-for="inputUnitCount" description="">
                                                  <b-form-input id="inputUnitCount" type="text" maxlength="70" v-model="form.unit_count" @focus.native="onFieldFocus" @blur.native="onFieldBlur" placeholder=""></b-form-input>
                                              </b-form-group>
                                          </b-col>

                                          <b-col sm="12" md="4">
                                              <b-form-group id="inputGroup5" label="Deadline" label-for="inputDeadline" description="">
                                                  <b-form-input id="inputDeadline" type="text" maxlength="70" v-model="form.deadline" @focus.native="onFieldFocus" @blur.native="onFieldBlur" placeholder=""></b-form-input>
                                              </b-form-group>
                                          </b-col>

                                          <b-col sm="12" md="4">
                                              <b-form-group id="inputGroup6" label="Budget" label-for="inputBudget" description="">
                                                  <b-form-input id="inputBudget" type="text" maxlength="70" v-model="form.budget" @focus.native="onFieldFocus" @blur.native="onFieldBlur" placeholder=""></b-form-input>
                                              </b-form-group>
                                          </b-col>

                                      </b-form-row>

                                      <b-form-row>

                                          <b-col sm="12" md="6">
                                              <b-form-group id="inputGroup7" label="Do you like ice cream?" label-for="inputIceCream" description="">
                                                  <b-form-input id="inputIceCream" type="text" maxlength="70" v-model="form.ice_cream" @focus.native="onFieldFocus" @blur.native="onFieldBlur" placeholder=""></b-form-input>
                                              </b-form-group>
                                          </b-col>

                                          <b-col sm="12" md="6">
                                              <b-form-group id="inputGroup8" label="What is your favorite animal?" label-for="inputFavoriteAnimal" description="">
                                                  <b-form-input id="inputFavoriteAnimal" type="text" maxlength="70" v-model="form.favorite_animal" @focus.native="onFieldFocus" @blur.native="onFieldBlur" placeholder=""></b-form-input>
                                              </b-form-group>
                                          </b-col>

                                      </b-form-row>
                                </b-collapse>
                                <!-- END COLLAPSE CONTENT -->

                                    <b-form-row class="justify-content-between mb-5">

                                        <b-col cols="auto" class="mr-auto">

                                            <b-button type="submit" class="animated" @click.native="onBtnClick($event) + doRecaptcha()" key="0" v-bind:disabled="(!isComplete || sending)" v-bind:class="{ swing: isComplete }">
                                                <span class="label">Send!</span>
                                                <span class="icon">
                                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve">
                                                        <path d="M485.5,282.8C485.5,282.8,485.5,282.7,485.5,282.8c-32.2-23.7-65.5-43.8-101.7-62.3c-30.3-15.8-51.2-10.6-83.4,6l-65.8,34 c60.6,27.2,128.2,68.8,195.3,114.7c0.1,0,0.1,0,0.2,0c37.2,23.7,73.8,48.4,109.2,73.9c42.2,30.6,79.2,58.9,122.6,91.3 c-43.3,32.4-80.4,60.7-122.6,91.3C482.9,672.1,424,711,363.7,746.2c-47.8,27.6-79.8,37-122.7,40.8c-2.7,50,8.3,70.2,53.7,79.2 c41.1,8.1,84.1-1.3,123.2-25C534.7,771.2,813.4,564.1,845,540.3C818.5,520.4,618.3,371.6,485.5,282.8z"/>
                                                    </svg>
                                                </span>
                                            </b-button>

                                            <b-button type="reset" class="btn-reset animated" @click.prevent="onResetBtnClick" key="1">
                                                <span class="label">Cancel!</span>
                                            </b-button>

                                        </b-col>
                                    </b-form-row>

                                    <b-form-row class="justify-content-between">
                                        <b-col cols="auto">

                                            <recaptcha
                                                    ref="recaptcha"
                                                    @verify="onSubmit"
                                                    data-aos="fade-up"
                                                    data-aos-duration="300"
                                                    data-aos-delay="0"
                                                    data-aos-easing="ease-in-out-quad"
                                                    data-aos-offset="0"
                                                    data-aos-anchor=""
                                                    data-aos-anchor-placement="top-bottom"
                                                    data-aos-once=""></recaptcha>

                                            <a
                                                    class="neoLink"
                                                    target="_blank"
                                                    href="https://www.neo-pangea.com/"
                                                    data-aos="fade-up"
                                                    data-aos-duration="300"
                                                    data-aos-delay="0"
                                                    data-aos-easing="ease-in-out-quad"
                                                    data-aos-offset="0"
                                                    data-aos-anchor=""
                                                    data-aos-anchor-placement="top-bottom"
                                                    data-aos-once="">A NeoPangea joint.</a>

                                        </b-col>

                                    </b-form-row>

                                  </b-form>

                            <div class="form-success" v-if="(!show && submitted)">

                                <h2 class="form-heading"
                                    data-aos="fade-right"
                                    data-aos-duration="300"
                                    data-aos-delay="50"
                                    data-aos-easing="ease-in-out-quad"
                                    data-aos-offset="0"
                                    data-aos-anchor=""
                                    data-aos-anchor-placement="top-bottom"
                                    data-aos-once="">{{ thankYou.headline }}</h2>

                                <div class="description"
                                     v-html="thankYou.description"
                                     data-aos="fade-up"
                                     data-aos-duration="300"
                                     data-aos-delay="50"
                                     data-aos-easing="ease-in-out-quad"
                                     data-aos-offset="0"
                                     data-aos-anchor=""
                                     data-aos-anchor-placement="top-bottom"
                                     data-aos-once=""></div>

                            </div>

                        </div>

                    </b-col>

                </b-row>

            </scroll-item>

            <div class="strip strip_0"></div>
            <div class="strip strip_2"></div>
            <div class="strip strip_3"></div>

        </b-container>

        <div class="gradient-wrapper"></div>

        <div class="animation-wrapper">
            <animated-monster></animated-monster>
            <img class="anim-bg" src="/static/images/_fpo/anim-seabass.png" />
        </div>

    </section>

</template>


<script>
    import axios from 'axios';
    import AnimatedMonster from "./AnimatedMonster";
    import Recaptcha from "./Recaptcha";

    let vm = {};

    export default {

        name: 'Contact',

        components: {
            Recaptcha,
            AnimatedMonster
        },

        data() {
            return {
                form: {
                    name: '',
                    email: '',
                    help: '',
                    unit_count: '',
                    deadline: '',
                    budget: '',
                    ice_cream: '',
                    favorite_animal: ''
                },
                maxCount: 280,
                remainingCount: 280,
                exceededCount: false,
                errors: [],
                show: true,
                sending: false,
                submitted: false,
                thankYou: {
                    headline: 'Thanks!',
                    description: '<span class="highlight pink">We\'ve heard the call and one of our cyber-ninja masters will be in touch with you before you can say </span><!--  --><span class="highlight white">&quot;Stupendous!&quot;</span>'
                },
                monsterAnimationObj: null,
                monsterAnimationState: true
            }
        },

        created() {
            vm = this;

            vm.$eventBus.$on('monster::ready', () => {
                console.log('monster ready!!');
                vm.monsterAnimationObj = window.monsterAnimation;
                vm.setupMonsterObserver();
            });
        },

        mounted() {
            vm = this;
        },

        computed: {

            /**
             * @method isComplete
             * @description
             * @returns {Boolean}
             */
            isComplete() {
                return !!(this.form.name && this.form.email && this.form.help) && this.validateEmail(this.form.email);
            }

        },

        watch: {

            monsterAnimationState(nVal, oVal) {
                console.log('%cmonsterAnimationState', 'color:dodgerblue;', nVal, oVal);

                if (nVal) {
                    this.startAnimatedMonster();
                } else {
                    this.stopAnimatedMonster();
                }
            }

        },

        methods: {

            /**
             * @method onBtnClick
             * @description
             * @param {Object} evt
             */
            onBtnClick(evt) {
                let el = evt.currentTarget;

                el.classList.add('tada');
            },

            /**
             * @method onResetBtnClick
             * @description
             * @param {Object} evt
             */
            onResetBtnClick(evt) {
                let el = evt.currentTarget;

                el.classList.add('tada');
                this.onReset(evt);
            },

            /**
             * @method onFieldClick
             * @description
             * @param {Object} evt
             */
            onFieldClick(evt) {
                let el = evt.currentTarget;
                console.log('el', el);
            },

            /**
             * @method onFieldFocus
             * @description
             * @param {Object} evt
             */
            onFieldFocus(evt) {
                let el = evt.currentTarget;
                let fieldLabel = document.querySelector('label[for="' + el.id + '"]');

                fieldLabel.classList.add('focused');
            },

            /**
             * @method onFieldBlur
             * @description
             * @param {Object} evt
             */
            onFieldBlur(evt) {
                let el = evt.currentTarget;
                let fieldLabel = document.querySelector('label[for="' + el.id + '"]');

                fieldLabel.classList.remove('focused');
            },

            /**
             * @method onSubmit
             * @description
             * @param {Object} evt
             */
            onSubmit(evt) {
                evt.preventDefault();

                if (!this.validateEmail(this.form.email)) {
                    return false;
                }

                this.sending = true;

                let _rawData = JSON.stringify(this.form),
                    _formData = new FormData();

                _formData.append('data', _rawData);

                axios.post('/static/lib/mailer.php', _formData).then(function(res) {
                    console.log('SUCCESS!!', res);
                    // reset form input fields
                    vm.onReset(evt);
                    // display successful submission message
                    vm.show = false;
                    vm.submitted = true;
                    vm.sending = false;
                    // ga track event
                    vm.$ua.trackEvent('Contact', 'Submit', 'Lead Generation');
                }).catch(function(err) {
                    console.log('ERROR!!', err);
                    vm.sending = false;
                });
            },

            /**
             * @method onReset
             * @description
             * @param {Object} evt
             */
            onReset(evt) {
                evt.preventDefault();

                // reset form values
                this.form.name = '';
                this.form.email = '';
                this.form.help = '';
                this.form.unit_count = '';
                this.form.deadline = '';
                this.form.budget = '';
                this.form.ice_cream = '';
                this.form.favorite_animal = '';

                if (evt && evt.type === 'click') {
                    // reset/clear browser validation hack
                    this.show = true;
                    this.sending = false;
                    //this.$nextTick(() => { this.show = true; });
                }
            },

            /**
             * @method doRecaptcha
             * @description
             */
            doRecaptcha() {
                this.$refs.recaptcha.execute();
            },

            /**
             * @method charCountdown
             * @description
             */
            charCountdown() {
                this.remainingCount = this.maxCount - this.form.help.length;
                this.exceededCount = this.remainingCount < 0;
            },

            /**
             * @method updateState
             * @description
             * @param {Object} state
             */
            updateState(state) {
                this.state = state;
            },

            /**
             * @method onChange
             * @description
             * @param {Object} state
             */
            onChange(state) {
                console.log('change', state);
            },

            /**
             * @method validateEmail
             * @description
             * @param {String} email
             * @returns {Boolean}
             */
            validateEmail(email) {
                // eslint-disable-next-line
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            /**
             * @method startAnimatedMonster
             * @description Start monster animation.
             */
            startAnimatedMonster() {
                console.log('%cstartAnimatedMonster', 'color:dodgerblue;', window.monsterAnimation);

                if (window.monsterAnimation && (typeof window.monsterAnimation.monsterStart === 'function')) {
                    window.monsterAnimation.monsterStart();
                }
            },

            /**
             * @method stopAnimatedMonster
             * @description Stop monster animation.
             */
            stopAnimatedMonster() {
                console.log('%cstopAnimatedMonster', 'color:dodgerblue;', window.monsterAnimation);

                if (window.monsterAnimation && (typeof window.monsterAnimation.monsterStop === 'function')) {
                    window.monsterAnimation.monsterStop();
                }
            },

            /**
             * @method setupMonsterObserver
             * @description
             */
            setupMonsterObserver() {
                console.log('%csetupMonsterObserver=>', 'color:dodgerblue;');

                let _container = document.querySelector('section#contact');

                // eslint-disable-next-line
                let _observer = new IntersectionObserver(function(entries, observer) {
                    entries.forEach(function(entry) {

                        //let _el = entry.target;
                        //console.log('_el', _el);

                        let _monsterElVisiblePct = (Math.floor(entry.intersectionRatio * 100) + '%');
                        console.log('_monsterElVisiblePct', _monsterElVisiblePct, entry.intersectionRatio);

                        if (entry.intersectionRatio >= 0.5) {
                            console.log('monster in view...playing', entry.intersectionRatio);
                            vm.monsterAnimationState = true;
                        } else {
                            console.log('monster out of view...pausing', entry.intersectionRatio);
                            vm.monsterAnimationState = false;
                        }
                    });
                }, { threshold: 0.5 });

                _observer.POLL_INTERVAL = 100;

                _observer.observe(_container);
            },

            toggleArrow(){
              let element = document.getElementsByClassName("arrow");
              element[0].classList.toggle("down");

            }

        }

    }

</script>


<style lang="scss" scoped>

    //@import '../assets/styles/helpers/variables';

    section {
        background: $black-100;
        color: rgba(255,255,255, 1.0);
        text-align: left;
        height: 100%;
        min-height: 600px;
        // max-height: 800px;
        padding: 0 0 0 0;
        position: relative;
        z-index: 1;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

        }

        @media (min-width: 992px) { // BLUE
            min-height: 800px;
            //max-height: 800px;
        }

        @media (min-width: 1200px) { // YELLOW

        }
    }

    .gradient-wrapper {
        background: linear-gradient(135deg, $gradient-end 0%, $gradient-start 100%);
        width: 100%;
        height: inherit;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        &::after {
            content: '';
            //background: linear-gradient(135deg, $gradient-end 0%, $gradient-start 100%);
            background-image: url(/static/images/gradient-blender.png);
            background-position: calc(50% + 52px);
            background-size: cover;
            width: 100%;
            height: 100%;
            overflow: hidden;
            opacity: 0.5;
            mix-blend-mode: soft-light;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            transform: translate3d(0, 0, 0);
            //filter: blur(20px);
        }
    }

    .content-wrapper {
        width: 100%;
        height: 100%;
        padding: 35px 15px;
        position: relative;
        top: 0;
        left: 0;
        z-index: 10;
        transition: all 0.3s $easeInOutQuad;


        @media (max-width: 374px) {
          padding-top:50px;
          padding-bottom:50px;
        }


        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN
            padding: 35px 15px;
        }

        @media (min-width: 992px) { // BLUE
            padding: 0px 15px;
        }

        @media (min-width: 1200px) { // YELLOW

        }
    }

    .animation-wrapper {
        width: 50%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        left: 50%;
        bottom: 0;
        z-index: 9;
        transition: all 0.3s $easeInOutQuad;

        @media (max-width: 374px) {
          left: 130px;
          width: 70%;
        }

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

        }

        @media (min-width: 992px) { // BLUE
            width: 40%;
            left: 60%;
        }

        @media (min-width: 1200px) { // YELLOW

        }

        & .anim-snap {
            position: absolute;
            bottom: 0;
            left: 200px;
            z-index: 5;
        }

        & .anim-bg {
            position: absolute;
            bottom: 0;
            z-index: 1;
        }
    }

    .section-header {
        margin: 0 0 1.5rem 0;
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

        }

        @media (min-width: 992px) { // BLUE
            margin: 0 0 2.5rem 0;
            flex-flow: row nowrap;
            align-items: center;
        }

        @media (min-width: 1200px) { // YELLOW

        }

        & .form-heading {
            font-family: $font-coconpro-bolditalic;
            font-size: 2.000rem;
            font-weight: normal;
            line-height: 1;
            margin: 0 0 8px 0;
            padding: 0 0 0 0;
            transition: all 0.3s $easeInOutQuad;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN

            }

            @media (min-width: 992px) { // BLUE
                font-size: 3.000rem;
                margin: 0 0 0 0;
                padding: 0 40px 0 0;
            }

            @media (min-width: 1200px) { // YELLOW

            }
        }

        & .form-intro {
            font-family: $font-coconpro-bolditalic;
            font-size: 0.875rem;
            font-weight: normal;
            line-height: 1.420;
            padding: 0 0 0 0;
            transition: all 0.3s $easeInOutQuad;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN

            }

            @media (min-width: 992px) { // BLUE
                padding: 0 0 0 0;
            }

            @media (min-width: 1200px) { // YELLOW
                font-size: 1rem;
                padding: 0 40px 0 0;
            }
        }
    }

    .form-container {
        position: relative;
        z-index: 5;
        padding: 5% 5% 0;

        @media (min-width: 992px) { // BLUE
            padding: 7% 0%;
        }
    }


    .strip {
        width: 560px;
        height: 100%;
        display: none;
        position: absolute;
        top: 0;
        z-index: 1;
        transform-origin: 50% 50%;
        transform: skew(-45deg);

        &:nth-last-of-type(1) {
            background: linear-gradient(45deg, rgba(185,87,159, 1) 0%, rgba(195,105,171, 1) 100%);
            left: -910px;
        }

        &:nth-last-of-type(2) {
            background: linear-gradient(135deg, rgba(149,43,134, 1) 0%,rgba(149,95,182, 1) 100%);
            left: 184px;
            height: 106%;
        }

        &:nth-last-of-type(3) {
            background: linear-gradient(45deg, rgba(198,111,175, 1) 0%,rgba(182,83,155, 1) 100%);
            left: 1680px;
        }
    }



    label {
        font-family: $font-coconpro-italic;
        font-size: 1.125rem;
        font-weight: normal;
        color: $white-100;
        line-height: 1;
        letter-spacing: -0.25px;
        text-shadow: 1px 1px 0 rgba(40,188,225, 0.0);
        display: block;
        transition: all 0.4s ease-in-out;

        &.focused {
            color: rgba(40,188,225, 1.0) !important;
            text-shadow: 1px 1px 0 darken(rgba(40,188,225, 1.0), 30%) !important;
            transition: all 0.4s ease-in-out;
        }
    }

    small {
        font-family: $font-coconpro-lightitalic;
        font-size: 0.75rem;
        font-weight: normal;
        line-height: 1;
        letter-spacing: -0.25px;
        color: $white-75 default !important;
    }

    .btn {
        font-family: $font-coconpro-bolditalic;
        font-size: 1.25rem;
        font-weight: normal !important;
        line-height: 1;
        letter-spacing: -0.25px;
        max-height: 64px;
        margin: 0 20px 0 0;
        padding: 0.750rem 1.0rem;
        outline: none !important;
        border: 0 none !important;
        border-radius: 1.875rem !important;
        box-shadow: 7px 7px 0 rgba(69,60,151, 0.6);
        transform-origin: 50% 50%;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

        }

        @media (min-width: 992px) { // BLUE
            font-size: 1.875rem;
            margin: 0 30px 0 0;
            padding: 1.063rem 1.250rem;
        }

        @media (min-width: 1200px) { // YELLOW

        }

        &:active {
            box-shadow: 2px 1px 0 rgba(69,60,151, 0.6);
            transform-origin: 100% 100%;
            transform: translateX(2px) translateY(1px);
            transition: all 0.3s $easeInOutQuad;
        }

        @media (hover:hover) {
            &:hover:not([disabled]) {
                animation: rubberBand 1s;
                transform-origin: 50% 50%;
                transition: all 0.4s ease-in-out;
            }
        }

        &[type='submit'] {
            background-color: rgba(40,188,225, 1.0);
            border-color: rgba(40,188,225, 1.0);
        }

        & .label {
            text-shadow: 3px 2px 0 rgba(69,60,151, 0.65);
        }

        & .icon {
            width: 24px;
            height: 24px;
            display: inline-block;
            vertical-align: text-bottom;
            transform-origin: 50% 50%;
            transform: scale(1.5);
            transition: all 0.3s $easeInOutQuad;

            @media (min-width: 576px) { // RED

            }

            @media (min-width: 768px) { // GREEN

            }

            @media (min-width: 992px) { // BLUE
                width: 30px;
                height: 30px;
                vertical-align: bottom;
            }

            @media (min-width: 1200px) { // YELLOW

            }

            & svg {
                filter: drop-shadow(2px 1px 0 rgba(69,60,151, 0.65));
            }
        }

        & path {
            fill: $white-100;
        }

        &.btn-reset {

        }
    }

    .form-control {
        background-color: $transparent !important;
        font-family: $font-coconpro-italic !important;
        font-size: 1.0rem !important;
        font-weight: normal !important;
        color: $white-100 !important;
        letter-spacing: -0.25px !important;
        padding: 0.125rem 0 !important;
        border-radius: 0 !important;
        border-color: $transparent !important;
        border: 1px solid $transparent !important;
        border-top: 1px solid $white-30 !important;
        outline: 0 !important;
        box-shadow: inset 0 2px 2px -2px $black-50 !important;
        transition: all 0.3s $easeInOutQuad;

        @media (min-width: 576px) { // RED

        }

        @media (min-width: 768px) { // GREEN

        }

        @media (min-width: 992px) { // BLUE
            font-size: 1.125rem !important;
            padding: 0.375rem 0 !important;
        }

        @media (min-width: 1200px) { // YELLOW

        }

        &:focus {
            background-color: $transparent !important;
            color: $white-100 !important;
            border-color: $transparent !important;
            border-top: 1px solid $transparent !important;
            border-bottom: 1px solid $white-30 !important;
            outline: 0 !important;
            box-shadow: 0 2px 2px -2px $black-50 !important;
        }
    }

    .text-muted {
        color: rgba(255, 255, 255, 0.6)!important;
    }
    .neoLink{
      display: inline-block;
      padding: 10px 3px 0px;
      cursor: pointer;
      margin-top: 20px;
    }
    .formToggle{
      margin: 20px 0px;
      color: hotpink;
      font-size: 1rem;
      cursor: pointer;
    }
    .formToggle:hover{
      color: #ff9cce;
      .arrow{
        border-color: #ff9cce;
      }
    }

    .arrow {
      border: solid hotpink;
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(-135deg);
      display: inline-block;
      margin-left: 3px;
    }
    .down{
      transform: translate(0px, -3px) rotate(45deg);
    }

</style>

<style lang="scss">

    .form-success {
        font-family: $font-coconpro-bolditalic;
        font-size: 2.000rem;
        font-weight: normal;
        line-height: 1.5;
        letter-spacing: -0.85px;
        margin: 0 0 2.500rem 0;

        & .form-heading {
            font-size: 4.500rem;
            margin: 0 1rem 2rem;
        }

        & .highlight {
            line-height: 1;
            padding: 0rem 1rem;
            display: inline;
            box-decoration-break: clone;

            &.blue {
                background-color: rgba(40,188,226, 1.0);
                color: $white-100;
            }

            &.pink {
                background-color: rgba(201,89,175, 1.0);
                color: $white-100;
            }

            &.white {
                background-color: $white-100;
                color: rgba(201,89,175, 1.0);
            }

            & .highlight {
                margin-right: -1rem;
            }
        }
    }
    #contact{
      display: flex;
      justify-content:center;
      align-items: center;
      flex-direction: column;
      padding-bottom: 50px;
    }

</style>
